var IpcPthPadGeneratorData = require('./ipcPthPadGeneratorData.js');
var lib_core = require("lib-core");
var lib_geometry = require("lib-geometry");
var PathData = require('../../../svg/pathData.js');
var HoleData = require('../../holeData.js');
var RectangleData = require('../../../svg/rectangleData.js');
var EllipseData = require('../../../svg/ellipseData.js');
var PathObjectData = require('../../../svg/pathObjectData.js');
var PathType = require('../../../svg/pathType.js');
var PthComponentAttribute = require('./pthComponentAttribute.js');
var IPCRules = require('../ipcRules');
var PthPadstackData = require('../../../padstack/pthPadstackData.js');
var SmdPadstackData = require('../../../padstack/smdPadstackData.js');
var CustomPadStackData = require('../../../padstack/customPadstackData.js');
var ThermalConnectionTypes = require("../../../thermalConnectionTypes.js");
var PadData = require('../../padData.js');

var MountingHoleData = function(position, angle, init) {
    var self = this;
    IpcPthPadGeneratorData.apply(this, arguments);

    this.withPad = this.value("withPad", true);
    this.plated = this.value("plated", true);
    
    this.padDiameter = this.value("padDiameter", true);
    this.holeDiameter = this.value("holeDiameter", true);
    
    this.withVia = this.value("withVia", true);
    this.viaCount = this.value("viaCount", true);
    this.viaDiameter = this.value("viaDiameter", true);
    this.viaCenterOffset = this.value("viaCenterOffset", true);
    this.viaThermalRelief = this.value("viaThermalRelief", true);

    this.nonTransformedSegmentedGeometry.addTrigger(this.padDiameter);
    this.nonTransformedSegmentedGeometry.addTrigger(this.holeDiameter);
    this.nonTransformedSegmentedGeometry.addTrigger(this.plated);
    this.nonTransformedSegmentedGeometry.addTrigger(this.withPad);
    this.nonTransformedSegmentedGeometry.addTrigger(this.withVia);
    this.nonTransformedSegmentedGeometry.addTrigger(this.viaCount);
    this.nonTransformedSegmentedGeometry.addTrigger(this.viaDiameter);
    this.nonTransformedSegmentedGeometry.addTrigger(this.viaCenterOffset);
    this.nonTransformedSegmentedGeometry.addTrigger(this.viaThermalRelief);

    this.withPad.onChange(this, function(val) {
        if (!val) {
            self.plated(false);
            self.withVia(false);
            self.viaThermalRelief(false);
        }
    });
};

lib_core.inherit(MountingHoleData, IpcPthPadGeneratorData);
lib_core.JsonParser.registerClass(MountingHoleData, "MountingHoleData");

module.exports = MountingHoleData;

/*
    Plated Hole with pad
    Non-Plated Hole with/without pad
    IPC does not support Plated Hole without pad
 */
MountingHoleData.prototype.getMotif = function() {
    if (this.padDiameter() == 0) return null;
    
    var shape = this.getPadShapeData();

    if (this.plated() && this.withPad()) { // Plated Hole with pad
        shape.width(this.padDiameter());
        shape.height(this.padDiameter());

        var padstack = new PthPadstackData(shape, shape.clone(), this.getHoleMotif(), true, false, 101.6, ThermalConnectionTypes.NO);
        var motif = new PadData(new lib_geometry.Coord(0, 0), 0, "__pthPadReplicatorMotif__", padstack, true);
        return motif;
    } else if (!this.plated() && this.withPad()) { // Non-Plated Hole with pad
        shape.width(this.padDiameter());
        shape.height(this.padDiameter());

        var padstack = new PthPadstackData(shape, shape.clone(), undefined, true, false, 101.6, ThermalConnectionTypes.NO);
        var motif = new PadData(new lib_geometry.Coord(0, 0), 0, "__pthPadReplicatorMotif__", padstack, true);
        return motif;
    }

    return null;
}

MountingHoleData.prototype.getViaPadMotif = function(dia) {
    var hole = this.getMotifHoleData(dia);
    this.calculatePadSize(hole.shape().width());

    var shape = new EllipseData(new lib_geometry.Coord(0, 0), 0, 0, 0, true, 0);
    shape.width(this.padGeometry.width);
    shape.height(this.padGeometry.length);

    var viaThermalReliefType = this.viaThermalRelief() ? ThermalConnectionTypes.RELIEF : ThermalConnectionTypes.NO;
    var padstack = new PthPadstackData(shape, shape.clone(), hole, true, false, 101.6, viaThermalReliefType);
    var motif = new PadData(new lib_geometry.Coord(0, 0), 0, "__pthPadReplicatorMotif__", padstack, true);
    return motif;
}

/**
 * Calculate pads geometry
 * @param  {boolean} absolutePositions
 * @return {array} Array of pads.
 */
MountingHoleData.prototype.getPads = function(absolutePositions) {
    var self = this;
    var pads = [];
    var motif = this.getMotif();

    if (motif) {
        // main pad
        pads.push(motif.clone());
        
        //add vias
        if (this.withVia() && this.viaCount() > 0) {
            var viaPadMotif = this.getViaPadMotif(this.viaDiameter());
            var viaAngleInterval = -2 * Math.PI / this.viaCount();

            for (var i = 0; i < this.viaCount(); i++) {
                var clonedViaPadMotif = viaPadMotif.clone();

                var viaPosX = this.viaCenterOffset() * Math.cos(Math.PI / 2 + i * viaAngleInterval);
                var viaPosY = this.viaCenterOffset() * Math.sin(Math.PI / 2 + i * viaAngleInterval);
                clonedViaPadMotif.move(new lib_geometry.Coord(viaPosX, viaPosY));
                pads.push(clonedViaPadMotif);
            }
        }  
    }

    self.updatePads(pads, absolutePositions);
    return pads;
};

MountingHoleData.prototype.getHoleMotif = function() {
    var drillShape = new EllipseData(new lib_geometry.Coord(0, 0), 0, this.holeDiameter(), this.holeDiameter(), true, 0);
    var hole = new HoleData(new lib_geometry.Coord(0,0), 0, drillShape);
    return hole;
};

MountingHoleData.prototype.getHoles = function(absolutePositions) {
    var holes = [];
    var holeMotif = this.getHoleMotif();

    holes.push(holeMotif.clone());

    //apply transform on holes if absolute position flag is true
    if (absolutePositions) {
        this.updateObjectTransformation(holes);
    }

    return holes;
};

/**
 * Calculate silkscreen for selected component. Silkscreen is calculated from body and pads geometry.
 * @param  {array} pads Pads calculated from getPads() function.
 * @return {array} Array of silkscreen data
 */
MountingHoleData.prototype.getSilkscreen = function(pads) {
    if (pads.length === 0) return [];

    var silkscreen = [];
    var body = this.getBodyForSilkscreen();
    var padWithClearance = this.padDiameter() + 2 * IPCRules.silkscreenClearance;

    if (this.padShape() === PthComponentAttribute.padShapes["Square"]) {
        // if pad's diagonal with clearance is less than body diameter draw silkscreen
        if (body.width * body.width > 2 * padWithClearance * padWithClearance) {
            silkscreen.push(new EllipseData(new lib_geometry.Coord(0,0), 0, body.width, body.width, false, IPCRules.silkscreenStrokeWidth));
        } else {
            // if pad's width is more than body diameter do not draw any silkscreen
            if (body.width > padWithClearance) {
                var a = padWithClearance / 2;
                var h = 0.5 * Math.sqrt(body.width * body.width - padWithClearance * padWithClearance);

                //right arc
                var pathData = new PathData(new lib_geometry.Coord(a, h), IPCRules.silkscreenStrokeWidth);
                pathData.addObject(new PathObjectData(new lib_geometry.Coord(a, -h), PathType.ARC, new lib_geometry.Coord(a, h), new lib_geometry.Coord(a, -h), body.width/2, body.width/2));
                silkscreen.push(pathData);

                // left arc
                pathData = pathData.clone();
                pathData.flip(new lib_geometry.Line(lib_geometry.Line.VER, new lib_geometry.Coord(0, 0)));
                silkscreen.push(pathData);

                //top arc
                pathData = new PathData(new lib_geometry.Coord(-h, a), IPCRules.silkscreenStrokeWidth);
                pathData.addObject(new PathObjectData(new lib_geometry.Coord(h, a), PathType.ARC, new lib_geometry.Coord(-h, a), new lib_geometry.Coord(h, a), body.width/2, body.width/2));
                silkscreen.push(pathData);

                // bottom arc
                pathData = pathData.clone();
                pathData.flip(new lib_geometry.Line(lib_geometry.Line.HOR, new lib_geometry.Coord(0, 0)));
                silkscreen.push(pathData);
            }
        }
    } else {
        // if body diameter is greater than pad diameter draw silkscreen
        if (body.width > padWithClearance) {
            silkscreen.push(new EllipseData(new lib_geometry.Coord(0,0), 0, body.width, body.width, false, IPCRules.silkscreenStrokeWidth));
        }
    }

    return silkscreen;
};

MountingHoleData.prototype.getAssemblyOutline = function(pads) {
    var body = this.getBodyForAssembly();
    var outline = new EllipseData(new lib_geometry.Coord(0,0), 0, body.width, body.width, false, IPCRules.assemblyOutlineStrokeWidth);
    return outline;
};